import React, { useEffect, useState } from 'react';
import { ActivityIndicator, View } from 'react-native';
import Text from '@/components/Typography/Text';
import { accountApi } from '@/lib/api';
import { loadCachedUsage, readUsageCache } from '@/lib/usageCache';
import { formatUsageNumber as number } from './usageInsights';

export default function WorkUsageDetails({ accountId, taskId, tx, button, refreshVersion = 0 }) {
  const key = `task:${taskId}`;
  const [detail, setDetail] = useState(() => readUsageCache(accountId, key).value);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setError(false);
    loadCachedUsage(accountId, key, () => accountApi.getWorkUsageDetail(taskId), { force: retry > 0 })
      .then(result => { if (!cancelled) setDetail(result); })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [accountId, key, taskId, retry, refreshVersion]);
  const cost = (label, credits) => <View key={label} style={{ flexDirection: 'row', justifyContent: 'space-between', gap: 12 }}><Text size="s" style={{ flex: 1 }}>{label}</Text><Text size="s" weight="bold">{number(credits)} {tx('creditsColumn')}</Text></View>;
  return <View style={{ gap: 12, paddingVertical: 12 }}>
    <Text size="xs" color="secondary">{tx('fullTaskBreakdown')}</Text>
    {detail && <>
      {detail.models.map(model => cost(model.name, model.credits))}
      {detail.browserCredits > 0 && cost(tx('browserUsage'), detail.browserCredits)}
      {detail.unattributedCredits > 0 && cost(tx('unattributedTaskCosts'), detail.unattributedCredits)}
      {cost(tx('taskTotal'), detail.totalCredits)}
      {detail.totalsMismatch && <Text size="xs" color="secondary">{tx('taskTotalsMismatch')}</Text>}
    </>}
    {!detail && !error && <ActivityIndicator accessibilityLabel={tx('loadingWorkCosts')} />}
    {error && <><Text size="s" color="secondary">{tx('workCostsFailed')}</Text>{button(tx('retry'), () => setRetry(value => value + 1))}</>}
  </View>;
}
